import { render, staticRenderFns } from "./CCategoryIcon.vue?vue&type=template&id=74c3a13e&scoped=true&"
import script from "./CCategoryIcon.vue?vue&type=script&lang=ts&"
export * from "./CCategoryIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CCategoryIcon.vue?vue&type=style&index=0&id=74c3a13e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c3a13e",
  null
  
)

export default component.exports